<template>
  <form class="mt-n3">
    <p v-if="error" class="error">{{ error }}</p>
    <div class="form-group row">
      <label for="company-name">{{ $tc("company") }}</label>
      <span
        class="text-muted ml-2"
        cy-id="company-hover"
        v-b-popover.hover.html="$t('registrationCompanyUsersText')"
        :title="$tc('companyUser', 2, { n: '' })"
      >
        <i class="fa fa-info-circle"></i>
      </span>
      <input v-model.lazy="companyName" type="text" id="company-name" class="form-control" />
    </div>
    <div class="form-group row">
      <label for="email">{{ $t("email") }}</label>
      <input v-model.lazy="$v.user.email.$model" type="text" id="email" class="form-control" />
      <error-list :field="$v.user.email"></error-list>
    </div>
    <div class="form-group row">
      <label for="password">{{ $t("password") }}</label>
      <input v-model.lazy="$v.user.password.$model" type="password" id="password" class="form-control" />
      <error-list :field="$v.user.password"></error-list>
    </div>
    <div class="form-group row">
      <label for="password">{{ $t("confirmPassword") }}</label>
      <input
        v-model.lazy="$v.user.passwordConfirmation.$model"
        type="password"
        id="passwordConfirmation"
        class="form-control"
      />
      <error-list :field="$v.user.passwordConfirmation"></error-list>
    </div>

    <div class="form-group row">
      <label for="preset">{{ $t("companyType") }}</label>
      <b-form-select v-model="preset" cy-id="industry-select">
        <b-form-select-option v-for="preset in presets" :key="preset.id" :value="preset.id">
          {{ preset.name }}
        </b-form-select-option>
      </b-form-select>
      <error-list :field="$v.preset"></error-list>
    </div>

    <!--
    <div class="form-group row">
      <label for="selected-subscriptions">{{ $t("subscription") }}</label>
      <div class="col-md-12">
        <b-form-checkbox
          v-model="selectedSubscriptionIds"
          v-for="subscription in subscriptions"
          :key="subscription.id"
          :value="subscription.id"
          :disabled="subscription.is_readonly"
          >{{ subscription.name }}
        </b-form-checkbox>
      </div>
    </div>

    <div class="form-group row">
      <label for="partnerRef">{{ $t("partnerReference") }}</label>
      <input
        v-model.lazy="$v.partner_ref.$model"
        type="text"
        id="partnerRef"
        class="form-control"
      />
      <div v-if="this.partner" class="m-2">
        {{ $t("foundPartner") }}: <b>{{ this.partner.name }}</b>
        <img v-if="partner.logo" :src="partner.logo.filepath" class="logo" />
      </div>

      <error-list :field="$v.partner_ref"></error-list>
    </div>
    -->
    <div class="form-group row">
      <Terms />
      <b-form-checkbox v-model="termsConfirmation">
        {{ $t("iHaveReadAndAcceptTheTermsAndConditions") }}
      </b-form-checkbox>
    </div>
    <div></div>
    <div class="form-group row text-center">
      <b-col>
        <pw-button
          id="login"
          className="success"
          icon="fa-user-plus"
          :spinner="loading"
          :disabled="$v.user.$invalid"
          @accepted="register()"
          v-if="termsConfirmation == true"
        >
          {{ $t("createAccount") }}
        </pw-button>

        <b-button variant="outline-secondary" @click="toggleTermsInfo" block v-if="termsConfirmation == false">
          <span class="icon">
            <i class="fa fa-user-plus"></i>
          </span>
          {{ $t("readAndAcceptTheTermsAndConditions") }}
        </b-button>
      </b-col>
    </div>
  </form>
</template>

<script>
import { email, minLength, required, sameAs } from "vuelidate/lib/validators";
import Terms from "@/components/Terms/Terms";
import AuthService from "@/services/AuthService";
import CompanyService from "@/services/CompanyService";
import PresetService from "@/services/PresetService";
import SubscriptionService from "@/services/SubscriptionService";

export default {
  name: "RegisterForm",
  components: {
    Terms
  },
  props: {
    redirectRoute: { type: String, default: "home" }, // Route name
    redirectUrl: { type: String, default: null }, // Route URL - takes precedence over route name if defined!
    partnerRef: {
      type: String,
      required: false,
      default: null
    },
    company: {
      type: String,
      required: false,
      default: null
    },
    email: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      user: {
        email: this.email, // Note: can be injected from prop
        password: null,
        passwordConfirmation: null,
        first_name: "-",
        last_name: "-"
      },
      companyName: this.company, // Note: can be injected from prop
      partner_ref: this.partnerRef, // Note: can be injected from prop
      partner: null,
      sub_corona: true,
      error: null,
      loading: false,
      termsConfirmation: false,
      showTerms: false,
      invite: false,
      invite_company_id: null,
      presets: [],
      preset: null,
      subscriptions: [],
      selectedSubscriptionIds: []
    };
  },
  validations: {
    user: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      passwordConfirmation: {
        sameAsPassword: sameAs("password")
      }
    },
    companyName: {
      required
    },
    preset: {},
    partner_ref: {}
  },
  mounted() {
    this.getPresets();
    this.getSubscriptions();

    if (this.partner_ref) {
      this.getPartner();
    }
  },
  methods: {
    register() {
      this.loading = true;
      AuthService.register(
        this.companyName,
        this.user.email,
        this.user.password,
        this.user.first_name,
        this.user.last_name,
        null,
        this.$route.query["fortnox-authorization-code"],
        this.invite,
        null,
        this.partner_ref,
        this.sub_corona,
        this.preset,
        this.selectedSubscriptionIds
      )
        .then((response) => {
          if (response.status === 201) {
            this.error = null;

            if (this.redirectUrl) {
              this.$router.push(this.redirectUrl);
            } else {
              this.$router.push({ name: this.redirectRoute });
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.error = this.$t("errors.incorrectUsernameOrPassword");
            } else {
              this.error = this.$t("errors.generic");
            }
          } else {
            this.error = this.$t("errors.generic");
          }
        })
        .finally(() => (this.loading = false));
    },
    toggleTermsInfo() {
      this.showTerms = !this.showTerms;
    },
    getPresets() {
      PresetService.getPresets().then((presets) => {
        this.presets = presets;
      });
    },
    getSubscriptions() {
      SubscriptionService.getSubscriptionsByIsActive().then((subscriptions) => {
        this.subscriptions = subscriptions;

        //Temp fix
        let defaultSubscriptions = this.subscriptions.filter((s) => s.is_default);
        this.selectedSubscriptionIds = this.subscriptions.map((s) => s.id);
      });
    },
    getPartner() {
      CompanyService.getPartnerByPartnerRef(this.partner_ref)
        .then((company) => {
          this.partner = company;
        })
        .catch((error) => {
          this.partner = null;
        });
    }
  },
  watch: {
    partner_ref(value) {
      this.partner = null;

      if (this.partner_ref !== "") {
        this.getPartner();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 50px auto auto auto;
  text-align: left;
}

.error {
  color: red;
}

.logo {
  width: 100px;
  display: block;
  clear: both;
  margin: 1em;
}
</style>
